export default __webpack_public_path__ + "static/media/uy.e8755e6a.jpg";